<div class="loggerLineberty" *ngIf="show" cdkDrag>
    <div class="loggerLinebertyContainer">
        <div class="draggableContainer">
            <div class="draggableContainer2" cdkDragHandle>
                <mat-icon class="iconDrag">open_with</mat-icon>
                <div class="consoleTitle textCenter">
                    Lineberty Console
                </div>
            </div>
            <mat-icon (click)="clean()" class="iconCancel">block</mat-icon>
        </div>
        <div class="logLineContainer">
            <div class="logLine textLeft" *ngFor="let log of logStack">
                <span class="debug" *ngIf="log.type === 'debug'">[DEBUG]</span>
                <span class="info" *ngIf="log.type === 'info'">[INFO]</span>
                <span class="error" *ngIf="log.type === 'error'">[ERROR]</span>
                <span> {{log.message}} </span>
                <span> {{getData(log.data)}} </span>
            </div>
        </div>
    </div>
</div>
